import { render } from "./Report__Appeals.vue?vue&type=template&id=bfd25798"
import script from "./Report__Appeals.vue?vue&type=script&lang=js"
export * from "./Report__Appeals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__